import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-construction',
    templateUrl: './construction.component.html',
    styleUrls: ['./construction.component.css'],
    standalone: false
})
export class ConstructionComponent {

  // Mobile menu control
  mobileMenuOpen = false;
  isLoggedIn = false;
  profileImage: string = '';
  firstName: string = '';

  title = 'Legal Credentials';

  // Current year for footer
  currentYear = new Date().getFullYear();

  constructor(public router: Router) {}

  ngOnInit() {
    // Scroll to top on component load
    window.scrollTo(0, 0);
     const token = localStorage.getItem('TOKEN');
    this.isLoggedIn = !!token;

    if (this.isLoggedIn) {
      this.profileImage = localStorage.getItem('profileImg') || '';
      this.firstName = localStorage.getItem('first_name') || '';
    }

    const currentRoute = this.router.url;

    if (currentRoute.includes('videoconsult')) {
      this.title = 'Video Consultation';
    } else {
      this.title = 'Legal Credentials';
    }
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.mobile-menu') && !target.closest('.mobile-menu-btn')) {
      this.mobileMenuOpen = false;
    }
  }

  login() {
    this.router.navigate(['/login']);
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
